enum DialogList {
    UPDATE_PASSWORD = 'UPDATE_PASSWORD',
    LOGIN_SUBMIT_AUTH_CODE = 'LOGIN_SUBMIT_AUTH_CODE',
    FORGOT_PASSWORD = 'FORGOT_PASSWORD',
    EXPIRED_PASSWORD = 'EXPIRED_PASSWORD',
    GET_MERIDIANS = 'GET_MERIDIANS',
    ADD_TOWNSHIP = 'ADD_TOWNSHIP',
    ADD_SECTION = 'ADD_SECTION',
    ADD_TRACT = 'ADD_TRACT',
    ADD_HORIZON = 'ADD_HORIZON',
    ADD_COUNTY = 'ADD_COUNTY',
    ADD_OWNERSHIP = 'ADD_OWNERSHIP',
    COPY_OWNERSHIP = 'COPY_OWNERSHIP',
    MANAGE_LEASEHOLD = 'MANAGE_LEASEHOLD',
    ADD_ADDITIONAL_OWNERSHIP = 'ADD_ADDITIONAL_OWNERSHIP',
    ADD_WI_OWNERSHIP = 'ADD_WI_OWNERSHIP',
    ADD_OWNER = 'ADD_OWNER',
    EDIT_HORIZON = 'EDIT_HORIZON',
    DELETE_HORIZON = 'DELETE_HORIZON',
    SEQUENCE_HORIZONS = 'SEQUENCE_HORIZONS',
    EXAMINED_HISTORY = 'EXAMINED_HISTORY',
    SURFACE_EXAMINED_HISTORY = 'SURFACE_EXAMINED_HISTORY',
    LEASEHOLD_PICKER = 'LEASEHOLD_PICKER',
    LEASEHOLD_FILE_UPLOAD = 'LEASEHOLD_FILE_UPLOAD',
    AMENDMENT_TO_OGML = 'AMENDMENT_TO_OGML',
    OWNER_LIST_FILTER = 'OWNER_LIST_FILTER',
    LEASING_OWNER_SEARCH = 'LEASING_OWNER_SEARCH',
    CONFIRM_CLAUSE_DELETE = 'CONFIRM_CLAUSE_DELETE',
    AD_HOC_CLAUSE = 'AD_HOC_CLAUSE',
    PDF_VIEWER = 'PDF_VIEWER',
    PDF_WINDOW = 'PDF_WINDOW',
    CREATE_FEEDBACK = 'CREATE_FEEDBACK',
    DELETE_CLIENT = 'DELETE_CLIENT',
    DELETE_TRACT = 'DELETE_TRACT',
    DELETE_SECTION = 'DELETE_SECTION',
    CLAUSE_DESCRIPTION = 'CLAUSE_DESCRIPTION',
    CONFIRM_OWNERSHIP_DELETE = 'CONFIRM_OWNERSHIP_DELETE',
    ADD_STAFF = 'ADD_STAFF',
    ADD_LANDMAN = 'ADD_LANDMAN',
    ADD_COMMENT = 'ADD_COMMENT',
    EDIT_COMMENT = 'EDIT_COMMENT',
    STAFF_LANDMAN = 'STAFF_LANDMAN',
    EDIT_TOWNSHIP = 'EDIT_TOWNSHIP',
    DELETE_TOWNSHIP = 'DELETE_TOWNSHIP',
    EDIT_SECTION = 'EDIT_SECTION',
    LEASEHOLD_SAVE_BEFORE_ADDING_WI = 'LEASEHOLD_SAVE_BEFORE_ADDING_WI',
    ADD_ORRI_OWNERSHIP = 'ADD_ORRI_OWNERSHIP',
    CONFIRM_LEASEHOLD_OWNERSHIP_DELETE = 'CONFIRM_LEASEHOLD_OWNERSHIP_DELETE',
    CONFIRM_CONTRACT_OWNERSHIP_DELETE = 'CONFIRM_CONTRACT_OWNERSHIP_DELETE',
    MANAGE_AGREEMENTS = 'MANAGE_AGREEMENTS',
    ADD_TOWNSHIP_EAST = 'ADD_TOWNSHIP_EAST',
    ADD_MAP_EAST = 'ADD_MAP_EAST',
    CREATE_INVOICE = 'CREATE_INVOICE',
    MANAGE_DEVIATIONS = 'MANAGE_DEVIATIONS',
    CHOOSE_ACTIVE_LEASEHOLD = 'CHOOSE_ACTIVE_LEASEHOLD',
    AGREEMENT_STATUS = 'AGREEMENT_STATUS',
    VOID_AGREEMENT = 'VOID_AGREEMENT',
    TRACT_LIST_DELTA = 'TRACT_LIST_DELTA',
    ADD_LEASEHOLD = 'ADD_LEASEHOLD',
    DOCUMENT_MANAGEMENT = 'DOCUMENT_MANAGEMENT',
    DELETE_LEASEHOLD = 'DELETE_LEASEHOLD',
    CREATE_LESSEE = 'CREATE_LESSEE',
    DOCUMENT_VIEWER = 'DOCUMENT_VIEWER',
    LEASE_PACKET_BUILDER = 'LEASE_PACKET_BUILDER',
    DELETE_DOC = 'DELETE_DOC',
    LPR_VIEWER = 'LPR_VIEWER',
    CREATE_AMMENDMENT = 'CREATE_AMMENDMENT',
    DOWNLOAD_DBF = 'DOWNLOAD_DBF',
    OWNER_NOTE = 'OWNER_NOTE',
    ADD_OWNER_NOTE = 'ADD_OWNER_NOTE',
    ADD_INVOICE = 'ADD_INVOICE',
    DELETE_LEASE = 'DELETE_LEASE',
    ADD_RECORDING_FEE = 'ADD_RECORDING_FEE',
    CREATE_CHECK = 'CREATE_CHECK',
    MANAGE_CHECKS = 'MANAGE_CHECKS',
    MANAGE_INVOICE_GROUPS = 'MANAGE_INVOICE_GROUPS',
    EXTEND_CHECK_DUE_DATE = 'EXTEND_CHECK_DUE_DATE',
    EXTEND_LEASEHOLDS = 'EXTEND_LEASEHOLDS',
    STAFFING_LANDMEN = 'STAFFING_LANDMEN',
    ADD_RUNSHEET = 'ADD_RUNSHEET',
    CONFIRM_TRACT_DELETE = 'CONFIRM_TRACT_DELETE',
    MEMO_VIEWER = 'MEMO_VIEWER',
    OOP_VIEWER = 'OOP_VIEWER',
    FILE_TOO_LARGE_TO_UPLOAD = 'FILE_TOO_LARGE_TO_UPLOAD',
    ADD_PERSONNEL = 'ADD_PERSONNEL',
    SCORECARD_COMMENT = 'SCORECARD_COMMENT',
    DEFAULT_PAY_HISTORY = 'DEFAULT_PAY_HISTORY',
    DEFAULT_BILL_HISTORY = 'DEFAULT_BILL_HISTORY',
    EMPLOYEE_PAY_HISTORY = 'EMPLOYEE_PAY_HISTORY',
    FIND_VENDOR = 'FIND_VENDOR',
    ADD_VENDOR_INVOICES = 'ADD_VENDOR_INVOICES',
    FIND_PERSON = 'FIND_PERSON',
    FIND_AVAILABLE_ACCOUNTS = 'FIND_AVAILABLE_ACCOUNTS',
    DEFINE_BUDGET_CATEGORY = 'DEFINE_BUDGET_CATEGORY',
    WARNING = 'WARNING',
    VENDOR_REPORTS = 'VENDOR_REPORTS',
    EXCEL_FILE = 'EXCEL_FILE',
    ADD_VENDOR = 'ADD_VENDOR',
    ADD_VENDOR_EX = 'ADD_VENDOR_EX',
    AP_TERMS = 'AP_TERMS',
    REPORT_OPTIONS = 'REPORT_OPTIONS',
    CHOOSE_VOUCHERS_TO_PAY = 'CHOOSE_VOUCHERS_TO_PAY',
    ENTER_CHECK_NUMBER = 'ENTER_CHECK_NUMBER',
    CREATE_CHECK_WARNING = 'CREATE_CHECK_WARNING',
    VOID_VOUCHER = 'VOID_VOUCHER',
    TSDI_EMPLOYEES = 'TSDI_EMPLOYEES',
    CREDIT_CARD_STATEMENT_MAINTENANCE = 'CREDIT_CARD_STATEMENT_MAINTENANCE',
    LOAD_RAW_DATA_FILE = 'LOAD_RAW_DATA_FILE',
    OUTPUT_DESTINATION = 'OUTPUT_DESTINATION'
}

export default DialogList;



// WEBPACK FOOTER //
// ./src/dialogs.ts